
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import * as $ from 'jquery';

@Component({
  selector: 'app-howitworks',
  templateUrl: './howitworks.component.html',
  styleUrls: ['./howitworks.component.css'],
})

export class HowworksComponent {
  constructor(public activeModal: NgbActiveModal) {
  }
  closeVideoPreview() {
    this.activeModal.close(false);
  }
}